// #genai Phase 2 "Something went wrong" dialog — pixel-matched to Figma 269:22087 (desktop, 450px)
// and 269:22176 (mobile, 342px). Fired from BOTH AddAchPaymentMethod and AddCardPaymentMethod as
// the generic fallback whenever a submit attempt returns a backend error that isn't a known
// duplicate-payment-method code. Single "Ok" action dismisses (parent clears submitInfo); the
// body includes an underlined "contact customer support" mailto link. When a supportReference is
// provided (orphan 503 PersistenceFailedAfterTokenize), the copy also surfaces the reference.
import React from 'lib/react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'lib/translation';
import {
  EVButton,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import { CUSTOMER_SERVICE_EMAIL } from 'constants/AppConstants';
import SubmitErrorDialogsStyles from './SubmitErrorDialogsStyles';

function SomethingWentWrongDialog({ open, onOk, supportReference }) {
  const { t } = useTranslation();
  const classes = SubmitErrorDialogsStyles();

  // #genai Orphan 503 (PersistenceFailedAfterTokenize, §4.1): the payment method was verified
  // upstream but persistence failed, so we surface the supportReference the backend paged Support
  // with. Falls back to the generic "check your details / contact support" copy otherwise.
  const i18nKey = supportReference
    ? 'billing_information__pm_error_support_reference'
    : 'billing_information__pm_error_message';

  return (
    <EVDialog open={open} onClose={onOk} classes={{ paper: classes.dialog }}>
      <EVDialogTitle disableTypography className={classes.title}>
        {t('billing_information__pm_error_title')}
      </EVDialogTitle>
      <EVDialogContent className={classes.content}>
        <EVDialogContentText className={classes.message}>
          {/* #genai <supportLink> maps to a mailto anchor targeting the shared customer-service
              inbox — matches the AccountsDeletion "contact support" convention. */}
          <Trans
            i18nKey={i18nKey}
            values={{ reference: supportReference }}
            components={{
              supportLink: (
                <a
                  className={classes.supportLink}
                  href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}
                >
                  contact customer support
                </a>
              ),
            }}
          />
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions className={classes.actions}>
        <EVButton
          id="pm-error-ok-btn"
          variant="contained"
          className={classes.okButton}
          onClick={onOk}
        >
          {t('billing_information__pm_dialog_ok')}
        </EVButton>
      </EVDialogActions>
    </EVDialog>
  );
}

SomethingWentWrongDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  supportReference: PropTypes.string,
};

SomethingWentWrongDialog.defaultProps = {
  supportReference: null,
};

export default SomethingWentWrongDialog;
